import { Fragment, useEffect } from "react";
import { Outlet, useLoaderData, useSubmit,useLocation, useNavigation } from 'react-router-dom';

import { getTokenDuration } from '../utils/auth';
import AppHeader from "../components/AppHeader/AppHeader";
import AppFooter from '../components/AppFooter/AppFooter';

const Root = () => {
	  const token = useLoaderData();
	  const submit = useSubmit();
	  useEffect(() => {
		if (!token) {
		  return;
		}

		if (token === 'EXPIRED') {
		  submit(null, { action: '/logout', method: 'post' });
		  return;
		}

		const tokenDuration = getTokenDuration();
		console.log(tokenDuration);

		setTimeout(() => {
		  submit(null, { action: '/logout', method: 'post' });
		}, tokenDuration);
	  }, [token, submit]);

	function ScrollToTop() {
	  const location = useLocation();
	  const navigation = useNavigation();

	  useEffect(() => {
		if (navigation.state === 'idle') {
		  window.scrollTo(0, 0);
		}
	  }, [location.pathname, navigation.state]);

	  return null;
	}
	
    return (
        <Fragment>
			<ScrollToTop />
            <AppHeader/>
            <Outlet/>
            <AppFooter/>
        </Fragment>
    );
};

export default Root;